<template>
  <section
    id="checkoutPayment"
    :class="[openClass, 'expandable_section']"
  >
    <h2
      class="expandable_header"
      @click="updateSection(sectionName)"
    >
      {{ $t("checkout.payment.paymentMethod", { number: number }) }}
    </h2>

    <div class="expandable_content review-payment">
      <div v-if="valid">
        <p
          :class="[errs == null ? '' : 'errors']"
          @click="handleError(errs)"
        >
          {{ errs }}
        </p>

        <img
          src="https://d2xpg1khvwxlf1.cloudfront.net/production/images/original/16162-credit-cards-f4bc8299b8a663920defb494900e90e3.png"
          alt="Credit Cards"
        >

        <StripeForm
          v-if="selected"
          :address="paymentfields.address1"
          :address2="paymentfields.address2"
          :buttontext="placeOrderText"
          :city="paymentfields.city"
          :name="name"
          :phone="paymentfields.phoneNumber"
          :state="paymentfields.state"
          :zipcode="paymentfields.zipCode"
          includechecks="true"
          @card-added="placeOrder"
          @update-terms="updateTerm"
          @update-f1="updateF1"
        />
      </div>

      <button
        v-if="amountMissing"
        class="continue-button btn btn-primary"
        @click="updateSection('review')"
      >
        {{ $t('checkout.payment.reviewOrder') }}
      </button>

      <button
        v-if="billingInfoMissing"
        class="continue-button btn btn-primary"
        @click="updateSection('address')"
      >
        {{ $t("checkout.payment.updateInfo") }}
      </button>

      <div
        v-if="card.id != undefined"
        class="processing-payment loading"
      >
        <div class="loading-icon" />

        <button
          disabled
          class="continue-button continue-button btn btn-primary"
        >
          {{ $t("checkout.payment.processing",
                { amount: paymentfields.amountDecorated, numbers: card.last_4 }) }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
/* global ga pi Turbolinks */

import Api from '../cart/cart_api'
import CountryData from '../country_data'
import StripeForm from '../stripe_form/credit_card_form.vue'

export default {
  components: {
    StripeForm
  },

  props: {
    currentsection: {
      default: null,
      required: true,
      type: String
    },

    number: {
      default: null,
      required: false,
      type: Number
    },

    paymentfields: {
      default: {},

      address1: {
        default: null,
        required: false,
        type: String
      },

      address2: {
        default: null,
        required: false,
        type: String
      },

      amount: {
        default: null,
        required: false,
        type: Number
      },

      city: {
        default: null,
        required: false,
        type: String
      },

      companyName: {
        default: null,
        required: false,
        type: String
      },

      country: {
        default: null,
        required: false,
        type: String
      },

      firstName: {
        default: null,
        required: false,
        type: String
      },

      lastName: {
        default: null,
        required: false,
        type: String
      },

      orderId: {
        default: null,
        required: false,
        type: Number
      },

      phoneNumber: {
        default: null,
        required: false,
        type: String
      },

      purchaseOrderNumber: {
        default: null,
        required: false,
        type: String
      },

      state: {
        default: null,
        required: false,
        type: String
      },

      zipCode: {
        default: null,
        required: false,
        type: String
      }
    }
  },

  data() {
    return {
      acceptedTerms: false,
      card: {},
      errs: null,
      f1Consent: false,
      pardot_id: '',
      sectionName: 'payment',
    }
  },

  computed: {
    amountMissing() {
      return this.paymentfields.amount == undefined ||
             this.paymentfields.amount == null ||
             this.paymentfields.amount < 1
    },

    billingInfoMissing() {
      return jQuery.isEmptyObject(this.paymentfields.firstName) ||
             jQuery.isEmptyObject(this.paymentfields.lastName) ||
             jQuery.isEmptyObject(this.paymentfields.phoneNumber) ||
             jQuery.isEmptyObject(this.paymentfields.address1) ||
             jQuery.isEmptyObject(this.paymentfields.city) ||
             this.paymentfields.state == 'missing state value' ||
             jQuery.isEmptyObject(this.paymentfields.city) ||
             this.invalidCountry ||
             this.invalidPostalCode
    },

    formData() {
      return {
        checkout: {
          accepted_terms: this.acceptedTerms,
          address: this.paymentfields.address1,
          address2: this.paymentfields.address2,
          amount: this.paymentfields.amount,
          card_id: this.card.id,
          city: this.paymentfields.city,
          company_name: this.paymentfields.companyName,
          country: this.paymentfields.country,
          f1_consent: this.f1Consent,
          first_name: this.paymentfields.firstName,
          ga_id: this.gaId,
          last_name: this.paymentfields.lastName,
          order_id: this.paymentfields.orderId,
          pardot_id: this.pardotID(),
          phone_number: this.paymentfields.phoneNumber,
          purchase_order_number: this.paymentfields.purchaseOrderNumber,
          room_information: this.paymentfields.roomInformation,
          state: this.paymentfields.state,
          zip_code: this.paymentfields.zipCode
        }
      }
    },

    gaId() {
      if (typeof ga === 'function') {
        return ga(function(tracker) { return tracker.get('clientId') } )
      } else {
        return null
      }
    },

    invalidCountry() {
      return CountryData.blockedCountries().concat(
        ['', null, undefined]).includes(this.paymentfields.country)
    },

    invalidPostalCode() {
      if (['CA', 'US'].includes(this.paymentfields.country)) {
        return jQuery.isEmptyObject(this.paymentfields.zipCode)
      } else {
        // We only require code of US and Canada so empty zip is valid in all other cases
        return false
      }
    },

    name() {
      return `${this.paymentfields.firstName} ${this.paymentfields.lastName}`
    },

    openClass() {
      return (this.selected) ? 'open' : ''
    },

    placeOrderText() {
      return this.$t('checkout.payment.placeOrder', { amount: '' })
    },

    selected() {
      return this.currentsection == this.sectionName
    },

    valid() {
      return this.card.id == undefined &&
             !this.amountMissing &&
             !this.billingInfoMissing
    },
  },

  methods: {
    confirmPayment(paymentTermId, paymentIntentId) {
      let body = JSON.stringify({ checkout: {
        f1_consent: this.f1Consent,
        payment_intent_id: paymentIntentId,
        payment_term_id: paymentTermId,
      }})

      Api.checkoutConfirm(body).then(order => {
        if (order.redirect) {
          Turbolinks.visit(order.redirect)
        } else if (order.error) {
          this.card = {}
          this.errs = order.error
        } else {
          this.card = {}
          this.errs = this.$t('checkout.payment.couldNotProcess')
        }
      })
    },

    handleError(errs){
      if(errs == this.$t('checkout.payment.hotelNotAvailable')){
        Api.getOrder().then(order=>{
          location.pathname=`cart/items/${order.items[0].id}/hotels`
        })
      } else{
        errs=null
      }
    },

    handleSCA(order) {
      this.card.stripe.paymentIntentSCA(order.client_secret).then(result => {
        if (result.error) {
          this.card = {}
          this.errs = result.error.message
        } else {
          this.confirmPayment(order.payment_term_id, result.paymentIntent.id)
        }
      })
    },

    placeOrder(card) {
      if (!this.valid) { return }

      this.card = card

      Api.checkout(JSON.stringify(this.formData)).then(order => {
        if (order.redirect) {
          window.location.replace(order.redirect)
        } else if (order.client_secret) {
          this.handleSCA(order)
        } else if (order.error) {
          this.card = {}
          this.errs = order.error
        } else {
          this.card = {}
          this.errs = this.$t('checkout.payment.couldNotProcess')
        }
      })
    },

    pardotID() {
      try {
        return pi.tracker.visitor_id
      } catch (_) {
        null
      }
    },

    updateF1(bool) {
      this.f1Consent = bool
    },

    updateTerm(bool) {
      this.acceptedTerms = bool
    },

    updateSection(section) {
      this.$emit('section-update', section)
    }
  }
}
</script>
